var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMemo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8748 -0.00691604H3.12564C1.41362 -0.00691604 0.0292969 1.44162 0.0292969 3.23322V20.7673C0.0292969 22.5589 1.41355 24.0075 3.12564 24.0075H15.8748C17.5868 24.0075 18.9711 22.5589 18.9711 20.7673V3.23254C18.9711 1.44101 17.5868 -0.00732422 15.8748 -0.00732422V-0.00691604ZM4.36413 6.47302H12.0136V8.3789H4.36413V6.47302ZM12.2321 18.2895H4.21842V16.3836H12.2321V18.2895ZM14.7819 13.3344H4.21836V11.4285H14.7819V13.3344Z",
    fill: "#9FA2A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMemo);
export default __webpack_public_path__ + "static/media/IconMemo.181696e53597cdf2d749cb3cf7e6b59e.svg";
export { ForwardRef as ReactComponent };